import {
  SET_ACCOUNT_CATEGORIES_ERRORED,
  SET_ACCOUNT_CATEGORIES_FETCHING,
  REPLACE_ACCOUNT_CATEGORIES,
} from 'constants/account/categories';

import { CLEAR_ACCOUNT_DATA } from 'constants/actionTypes';

const initialState = {
  meta: {
    fetching: false,
    synced: false,
    errored: false,
  },
  data: {},
};

export default function categories(state = initialState, action) {
  switch (action.type) {
    case SET_ACCOUNT_CATEGORIES_FETCHING:
      return {
        ...state,
        meta: {
          fetching: true,
          synced: false,
          errored: false,
        },
      };
    case REPLACE_ACCOUNT_CATEGORIES:
      return {
        ...state,
        meta: {
          fetching: false,
          synced: true,
          errored: false,
        },
        data: action.payload,
      };
    case SET_ACCOUNT_CATEGORIES_ERRORED:
      return {
        ...state,
        meta: {
          fetching: false,
          synced: true,
          errored: true,
        },
      };
    case CLEAR_ACCOUNT_DATA:
      return initialState;
    default:
      return state;
  }
}

export const selectAccountCategories = state => state.account.categories.data;
export const selectAccountCategoriesMeta = state =>
  state.account.categories.meta;
export const selectAccountCategoriesSynced = state =>
  state.account.categories.meta.synced;
